import { getIntlLocale } from "@/i18n/translate";

/**
 * Dates and times in the UI language (not the browser's), for table cells, cards and details.
 * The year is shown only when it is not the current one.
 */

const parse = (value: string | Date | null | undefined) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const yearIfOld = (date: Date) =>
  date.getFullYear() !== new Date().getFullYear() ? { year: "2-digit" as const } : {};

/** "16. 10. 18:03" / "10/16, 6:03 PM" */
export const shortDateTime = (value: string | Date | null | undefined) => {
  const date = parse(value);
  if (!date) return value ? String(value) : "–";
  return date.toLocaleString(getIntlLocale(), {
    day: "numeric",
    month: "numeric",
    ...yearIfOld(date),
    hour: "2-digit",
    minute: "2-digit",
  });
};

/** full date and time with seconds: "16. 10. 2026 18:03:12" */
export const formatDateTime = (value: string | Date | null | undefined) => {
  const date = parse(value);
  if (!date) return value ? String(value) : "–";
  return date.toLocaleString(getIntlLocale());
};

/** "16. 10. 2026" */
export const formatDate = (value: string | Date | null | undefined) => {
  const date = parse(value);
  if (!date) return value ? String(value) : "–";
  return date.toLocaleDateString(getIntlLocale());
};

/** "18:03" / "6:03 PM" */
export const formatTime = (value: string | Date | null | undefined) => {
  const date = parse(value);
  if (!date) return value ? String(value) : "–";
  return date.toLocaleTimeString(getIntlLocale(), { hour: "2-digit", minute: "2-digit" });
};

/** "Thu 15. 10." (with the year when it is not this one) */
export const formatWeekdayDate = (value: string | Date | null | undefined) => {
  const date = parse(value);
  if (!date) return value ? String(value) : "–";
  return date.toLocaleDateString(getIntlLocale(), {
    weekday: "short",
    day: "numeric",
    month: "numeric",
    ...(date.getFullYear() !== new Date().getFullYear() ? { year: "numeric" as const } : {}),
  });
};
